// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-snackbar {
  justify-content: center;
  z-index: 10000;
  margin: 8px;
  margin-inline-end: calc(8px + var(--v-scrollbar-offset));
}
.v-snackbar:not(.v-snackbar--centered):not(.v-snackbar--top) {
  align-items: flex-end;
}
.v-snackbar__wrapper {
  align-items: center;
  display: flex;
  max-width: 672px;
  min-height: 48px;
  min-width: 344px;
  overflow: hidden;
  padding: 0;
  border-radius: 4px;
}
.v-snackbar--variant-plain, .v-snackbar--variant-outlined, .v-snackbar--variant-text, .v-snackbar--variant-tonal {
  background: transparent;
  color: inherit;
}
.v-snackbar--variant-plain {
  opacity: 0.62;
}
.v-snackbar--variant-plain:focus, .v-snackbar--variant-plain:hover {
  opacity: 1;
}
.v-snackbar--variant-plain .v-snackbar__overlay {
  display: none;
}
.v-snackbar--variant-elevated, .v-snackbar--variant-flat {
  background: rgb(var(--v-theme-surface-variant));
  color: rgb(var(--v-theme-on-surface-variant));
}
.v-snackbar--variant-elevated {
  box-shadow: 0px 3px 5px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 6px 10px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 18px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
.v-snackbar--variant-flat {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
.v-snackbar--variant-outlined {
  border: thin solid currentColor;
}
.v-snackbar--variant-text .v-snackbar__overlay {
  background: currentColor;
}
.v-snackbar--variant-tonal .v-snackbar__underlay {
  background: currentColor;
  opacity: var(--v-activated-opacity);
  border-radius: inherit;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}

.v-snackbar__content {
  flex-grow: 1;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  line-height: 1.25rem;
  margin-right: auto;
  padding: 14px 16px;
  text-align: initial;
}
.v-snackbar__actions {
  align-items: center;
  align-self: center;
  display: flex;
  margin-inline-end: 8px;
}
.v-snackbar__actions > .v-btn {
  padding: 0 8px;
  min-width: auto;
}
.v-snackbar__timer {
  width: 100%;
  position: absolute;
  top: 0;
}
.v-snackbar__timer .v-progress-linear {
  transition: 0.2s linear;
}
.v-snackbar--absolute {
  position: absolute;
  z-index: 1;
}
.v-snackbar--multi-line .v-snackbar__wrapper {
  min-height: 68px;
}
.v-snackbar--vertical .v-snackbar__wrapper {
  flex-direction: column;
}
.v-snackbar--vertical .v-snackbar__wrapper .v-snackbar__actions {
  align-self: flex-end;
  margin-bottom: 8px;
}

.v-snackbar-transition-enter-active, .v-snackbar-transition-leave-active {
  transition-duration: 0.15s;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.v-snackbar-transition-enter-active {
  transition-property: opacity, transform;
}
.v-snackbar-transition-enter-from {
  opacity: 0;
  transform: scale(0.8);
}
.v-snackbar-transition-leave-active {
  transition-property: opacity;
}
.v-snackbar-transition-leave-to {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VSnackbar/VSnackbar.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,wDAAwD;AAC1D;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,+CAA+C;EAC/C,6CAA6C;AAC/C;AACA;EACE,yOAAyO;AAC3O;AACA;EACE,sOAAsO;AACxO;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;AACxD;AACA;EACE,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ","sourcesContent":[".v-snackbar {\n  justify-content: center;\n  z-index: 10000;\n  margin: 8px;\n  margin-inline-end: calc(8px + var(--v-scrollbar-offset));\n}\n.v-snackbar:not(.v-snackbar--centered):not(.v-snackbar--top) {\n  align-items: flex-end;\n}\n.v-snackbar__wrapper {\n  align-items: center;\n  display: flex;\n  max-width: 672px;\n  min-height: 48px;\n  min-width: 344px;\n  overflow: hidden;\n  padding: 0;\n  border-radius: 4px;\n}\n.v-snackbar--variant-plain, .v-snackbar--variant-outlined, .v-snackbar--variant-text, .v-snackbar--variant-tonal {\n  background: transparent;\n  color: inherit;\n}\n.v-snackbar--variant-plain {\n  opacity: 0.62;\n}\n.v-snackbar--variant-plain:focus, .v-snackbar--variant-plain:hover {\n  opacity: 1;\n}\n.v-snackbar--variant-plain .v-snackbar__overlay {\n  display: none;\n}\n.v-snackbar--variant-elevated, .v-snackbar--variant-flat {\n  background: rgb(var(--v-theme-surface-variant));\n  color: rgb(var(--v-theme-on-surface-variant));\n}\n.v-snackbar--variant-elevated {\n  box-shadow: 0px 3px 5px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 6px 10px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 18px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-snackbar--variant-flat {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-snackbar--variant-outlined {\n  border: thin solid currentColor;\n}\n.v-snackbar--variant-text .v-snackbar__overlay {\n  background: currentColor;\n}\n.v-snackbar--variant-tonal .v-snackbar__underlay {\n  background: currentColor;\n  opacity: var(--v-activated-opacity);\n  border-radius: inherit;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n}\n\n.v-snackbar__content {\n  flex-grow: 1;\n  font-size: 0.875rem;\n  font-weight: 400;\n  letter-spacing: 0.0178571429em;\n  line-height: 1.25rem;\n  margin-right: auto;\n  padding: 14px 16px;\n  text-align: initial;\n}\n.v-snackbar__actions {\n  align-items: center;\n  align-self: center;\n  display: flex;\n  margin-inline-end: 8px;\n}\n.v-snackbar__actions > .v-btn {\n  padding: 0 8px;\n  min-width: auto;\n}\n.v-snackbar__timer {\n  width: 100%;\n  position: absolute;\n  top: 0;\n}\n.v-snackbar__timer .v-progress-linear {\n  transition: 0.2s linear;\n}\n.v-snackbar--absolute {\n  position: absolute;\n  z-index: 1;\n}\n.v-snackbar--multi-line .v-snackbar__wrapper {\n  min-height: 68px;\n}\n.v-snackbar--vertical .v-snackbar__wrapper {\n  flex-direction: column;\n}\n.v-snackbar--vertical .v-snackbar__wrapper .v-snackbar__actions {\n  align-self: flex-end;\n  margin-bottom: 8px;\n}\n\n.v-snackbar-transition-enter-active, .v-snackbar-transition-leave-active {\n  transition-duration: 0.15s;\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n}\n.v-snackbar-transition-enter-active {\n  transition-property: opacity, transform;\n}\n.v-snackbar-transition-enter-from {\n  opacity: 0;\n  transform: scale(0.8);\n}\n.v-snackbar-transition-leave-active {\n  transition-property: opacity;\n}\n.v-snackbar-transition-leave-to {\n  opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
